<template>
  <router-view />
</template>

<script lang="ts" setup>
import { RouterView, useRouter } from "vue-router";
import useUserInfo from "@/composables/auth/useUserInfo";

const props = defineProps<{
  routerPath: string;
}>();

const user = useUserInfo();
const router = useRouter();
// redirect any non-admins away from the equipment admin
if (!user.is_admin) {
  router.push("/");
}
// HACK - is there a way to set a default child component?
else if (
  props.routerPath.endsWith("/admin") ||
  props.routerPath.endsWith("/admin/")
) {
  router.push({ name: "Casings" });
}
</script>

<style lang="scss" scoped></style>
